import { render, staticRenderFns } from "./TFSBasicForm.vue?vue&type=template&id=23f33573&scoped=true&"
import script from "./TFSBasicForm.vue?vue&type=script&lang=js&"
export * from "./TFSBasicForm.vue?vue&type=script&lang=js&"
import style0 from "./TFSBasicForm.vue?vue&type=style&index=0&id=23f33573&prod&scoped=true&lang=scss&"
import style1 from "./TFSBasicForm.vue?vue&type=style&index=1&id=23f33573&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f33573",
  null
  
)

export default component.exports